

import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Drawer,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
  Divider,
  IconButton,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

import {
  Menu as MenuIcon,
  Home as HomeIcon,
  Person as PersonIcon,
  ShoppingCart as ShoppingCartIcon,
  Book as BookIcon,
  WhatsApp as WhatsappIcon,
  Storage as StorageIcon,
  People as PeopleIcon,
  Feedback as FeedbackIcon,
  PriceChange as PriceChangeIcon,
  LocalShipping as LocalShippingIcon,
  Subscriptions as SubscriptionsIcon,
  LocalOffer as LocalOfferIcon,
  Logout as LogoutIcon,
  Close as CloseIcon,
  Storefront as StorefrontIcon,
  Business as BusinessIcon,
  Assignment as AssignmentIcon,
  Science as ScienceIcon,
  ReportProblem as ReportProblemIcon,
  RateReview as RateReviewIcon,
  MedicalServices as MedicalServicesIcon,
  HealthAndSafety as HealthAndSafetyIcon,
  Campaign as CampaignIcon,
  AssignmentReturn as AssignmentReturnIcon,
  Redeem as RedeemIcon ,
  MonetizationOn as MonetizationOnIcon,
  CastForEducationOutlined as EducationIcon,
  HouseOutlined as CommunityIcon,
  Timeline as TimelineIcon,
  Campaign,
  PersonAddAltOutlined as PersonAddAltOutlinedIcon,
  EventAvailableOutlined as EventAvailableOutlinedIcon,
  LocalLaundryServiceOutlined as LocalLaundryServiceOutlinedIcon,
  ReceiptLongOutlined as ReceiptLongOutlinedIcon,
} from "@mui/icons-material";

import ayujaLogoLoggedOut from "../Logos/Ayuja_Logo.jpg"; 
import ayujaLogoLoggedIn from "../Logos/AuthLogo.png";  
import { fetchUserFromRedis } from "../AuthonticationPages/Register";
import CustomDialog from "../../CustomDialog";
import { apiRequest } from '../../fetchSetup';
import { ReactComponent as TabletIcon } from "../Logos/medicine-10-svgrepo-com.svg"
import NotificationManagement from "../AdminPages/WeeklyNotificationManagement";
import WatsappGupshupDashboard from "../watsappDashboard/WhatsappDashboard";

const DRAWER_WIDTH = 280;
function Header({username}) {
  const navigate = useNavigate();
  const location = useLocation();
  const [selected, setSelected] = useState("");
  const [user, setUser] = useState(null);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const logoutapi = process.env.REACT_APP_LOGOUT_API;

  useEffect(() => {
    const fetchUser = async () => {
      const userId = sessionStorage.getItem("userId");
      const token = sessionStorage.getItem("token");
      if (!userId || !token) {
        setUser(null);
        return;
      }
      try {
        const userData = await fetchUserFromRedis(userId, token);
        setUser(userData || null);
      } catch (err) {
        console.error("Error fetching user from Redis:", err);
        setUser(null);
      }
    };
    fetchUser();
  }, [location,username]);



  const getLogoSrc = () => {
    return user ? ayujaLogoLoggedIn : ayujaLogoLoggedOut;
  };


  const handleChange = (event, newValue) => {
    if (newValue !== null) setSelected(newValue);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleLogoutClick = () => {
    setLogoutDialogOpen(true);
  };

  const handleLogoutConfirm = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const userId = sessionStorage.getItem("userId");
      await apiRequest(`${logoutapi}/${userId}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      sessionStorage.clear();
      setUser(null);
      setLogoutDialogOpen(false);
      navigate("/Login");
    } catch (error) {
      console.error("Logout failed:", error);
      sessionStorage.clear();
      setLogoutDialogOpen(false);
      navigate("/Login");
    }
  };

  const handleLogoutCancel = () => {
    setLogoutDialogOpen(false);
  };

  const getHomeRoute = () => {
    if (!user) return "/";
    switch (user.role) {
      case "admin":
        return "/admin-dashboard";
      case "medicineadmin":
        return "/medicine-admin-dashboard";
      case "diagnosticadmin":
        return "/diagnostic-admin-dashboard";
      case "deliveryagent":
        return "/deliveryagent-dashboard";
      case "staff":
        return "/english";
      default:
        return "/";
    }
  };

  
  const handleNavigation = (path) => {
    navigate(path);
    if (mobileOpen) setMobileOpen(false);
  };

  const getMenuItems = () => {
    if (!user) return [];

    const userRole = user.role?.toLowerCase();
    const isPhlebotomist =
        userRole === "deliveryagent" && 
        user.agent_role === "sample_collection";
    const isStaff= userRole === "staff"
      const homeItem = {
        text: "Home",
        icon: <HomeIcon />,
        path: getHomeRoute(),
      };


    const commonItems = [
      { text: "Profile", icon: <PersonIcon />, path: "/profile-details" },
    ];
    
    const adminItems = [
      { text: "Orders Management", icon: <ShoppingCartIcon />, path: "/orders-management" },
      { text: "Store purchase", icon: <StorefrontIcon />, path: "/POSMedicineSystem" },
      { text: "Book Orders", icon: <BookIcon />, path: "/select-booking" },
      { text: "Master Data Management", icon: <StorageIcon />, path: "/diagnostic-masterdata" },
      { text: "User Management", icon: <PeopleIcon />, path: "/PendingUsers" },
      { text: "Doctor Appointments", icon: <EventAvailableOutlinedIcon />, path: "/doctor-appointments" },
      { text: "Laundry Orders", icon: <ReceiptLongOutlinedIcon />, path: "/laundry-orders" },
      { text: "Grocery Managemet", icon: <ReceiptLongOutlinedIcon />, path: "/grocery-management" },
      { text: "Notifications Management", icon:<Campaign />, path: "/NotificationManagement" },
      { text: "Whatsapp Management", icon: <WhatsappIcon />, path: "/WhatsappDashboard" },
      { text: "Festival Items Management", icon: <LocalShippingIcon />, path: "/festival-management" },
      
      { text: "Offers & Rewards", icon: <RedeemIcon />, path: "/PromotionDashboard" },
      { text: "Delivery Agent Management", icon: <PeopleIcon />, path: "/delivery-agent-management" },
      { text: "Delivery Orders Management", icon: <LocalShippingIcon />, path: "/delivey-orders-management" },
      { text: "Medicine Requests", icon: <MedicalServicesIcon />, path: "/medicine-requests-admin" },
      { text: "Payment Dashboard", icon: <MonetizationOnIcon />, path: "/payment-dashboard" },
      { text: "Overall FeedBack", icon: <RateReviewIcon />, path: "/AdminFeedbackDashboard" },
      { text: "Health Services Management", icon: <HealthAndSafetyIcon />, path: "/HealthServicesManagement" },
      { text: "Complaints & Feedback", icon: <FeedbackIcon />, path: "/complaints-dashboard" },
      { text: "Add Doctor", icon: <PersonAddAltOutlinedIcon />, path: "/appointmentdata" },
      { text: "Add Laundary Data", icon: <LocalLaundryServiceOutlinedIcon />, path: "/laundry-data" },
      { text: "Community management", icon: <CommunityIcon />, path: "/Community-services" },
      // { text: "Change Service Prices", icon: <PriceChangeIcon />, path: "/price-changes" },
    
      { text: "Activity Logs", icon: <TimelineIcon />, path: "/Audit-logs" },
      { text: "DistributorList", icon: <BusinessIcon />, path: "/DistributorList" },
      { text: "Purchase Order List", icon: <AssignmentIcon />, path: "/purchase-orders" },
      { text: "Medicine Return Management", icon: <AssignmentReturnIcon />, path: "/VendorReturns" },
      { text: "English Learning", icon: <EducationIcon/>, path: "/english" },
      { text: "Subscription Management", icon: <SubscriptionsIcon />, path: "/subscription-management" },
    ];

    const medicineAdminItems = [
      { text: "Store purchase", icon: <StorefrontIcon />, path: "/POSMedicineSystem" },
      { text: "Book Orders", icon: <BookIcon />, path: "/select-booking" },
      { text: "Orders Management", icon: <ShoppingCartIcon />, path: "/orders-management" },
      { text: "Master Data Management", icon: <StorageIcon />, path: "/diagnostic-masterdata" },
      { text: "Delivery Orders Management", icon: <LocalShippingIcon />, path: "/delivey-orders-management" },
      { text: "DistributorList", icon: <BusinessIcon />, path: "/DistributorList" },
      { text: "Purchase Order List", icon: <AssignmentIcon />, path: "/purchase-orders" },
      { text: "Complaints & Feedback", icon: <FeedbackIcon />, path: "/complaints-dashboard" },
      { text: "Medicine Requests", icon: <MedicalServicesIcon />, path: "/medicine-requests-admin" },
    ];

    const diagnosticAdminItems = [
      { text: "Book Orders", icon: <BookIcon />, path: "/select-booking" },
      { text: "Orders Management", icon: <ShoppingCartIcon />, path: "/orders-management" },
      { text: "Master Data Management", icon: <StorageIcon />, path: "/diagnostic-masterdata" },
      { text: "Delivery Orders Management", icon: <LocalShippingIcon />, path: "/delivey-orders-management" },
      { text: "Complaints & Feedback", icon: <FeedbackIcon />, path: "/complaints-dashboard" },
    ];
    const deliveryPersonItems = [
      { text: "Report Issue", icon: <ReportProblemIcon />, path: "/delivery-report-issue" },

    ];

      const phlebotomistItems = [
        { text: "Sample Collections", icon: <ScienceIcon />, path: "/PhlebotomistDashboard" },
        // { text: "Report Issue", icon: <ReportProblemIcon />, path: "/delivery-report-issue" }
      ];
      const staffItems=[
      { text: "English Learning", icon: <EducationIcon/>, path: "/english" },
      ]

    let roleItems = [];
    if (userRole === "admin") roleItems = adminItems;
    else if (userRole === "medicineadmin") roleItems = medicineAdminItems;
    else if (userRole === "diagnosticadmin") roleItems = diagnosticAdminItems;
    else if (userRole === "staff") roleItems = staffItems;
    else if (userRole === "deliveryagent") {
      // You need to store agent_role in user object when fetching user data
      const agentRole = user.agent_role || "delivery"; // default to delivery
      roleItems = agentRole === "sample_collection" ? phlebotomistItems : deliveryPersonItems;
    }
    // return [...commonItems, ...roleItems];
    return [
      ...(isPhlebotomist || isStaff ? [] : [homeItem]),
      ...commonItems,
      ...roleItems,
    ];
    
  };

  const drawer = (
    <Box sx={{ 
      height: "100vh", 
      display: "flex", 
      flexDirection: "column", 
      backgroundColor: "#f8f9fa",
      position: "relative"
    }}>
      {user && (
        <Box
          sx={{
            p: { xs: 1.5, sm: 2 },
            backgroundColor: "#006D77",
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: { xs: 1, sm: 1.5 },
            minHeight: { xs: "60px", sm: "70px" },
            flexShrink: 0
          }}
        >
                 
<Box
  sx={{
    position: "absolute",
    top: 25,
    right: -15,
    width: 100,
    height: 50,
    opacity: 0.3,
  }}
>
  <TabletIcon width="70%" height="70%"  />
</Box>    
            {/* Plus Icons */}
            <Box sx={{
              position: "absolute",
              top: 25,
              right: 21,
              width: 20,
              height: 20,
              opacity: 0.4,
              "&::before, &::after": {
                content: '""',
                position: "absolute",
                background: "white"
              },
              "&::before": {
                width: "100%",
                height: 7,
                top: "50%",
                transform: "translateY(-50%)"
              },
              "&::after": {
                height: "100%",
                width: 7,
                left: "50%",
                transform: "translateX(-50%)"
              }
            }} />
          
          <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 1, sm: 1.5 }, flex: 1, minWidth: 0 }}>
            <img
              // src={ayujalogo}
              src={getLogoSrc()}  
              alt="Ayuja Logo"
              style={{ 
                height: "clamp(28px, 5vw, 35px)", 
                cursor: "pointer", 
                flexShrink: 0,
                maxWidth: "100%",
                objectFit: "contain"
              }}
              onClick={() => navigate(getHomeRoute())}
            />

            <Box sx={{ minWidth: 0, flex: 1 }}>
              <Typography 
                variant="caption" 
                sx={{ 
                  display: "block", 
                  opacity: 0.9, 
                  fontSize: "clamp(9px, 1.8vw, 11px)" 
                }}
              >
                Welcome
              </Typography>
              <Typography 
                variant="h6" 
                sx={{ 
                  fontWeight: "bold", 
                  fontSize: "clamp(13px, 2.5vw, 16px)",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  lineHeight: 1.2
                }}
              >
                {user.name}
              </Typography>
            </Box>
          </Box>

          <IconButton
            onClick={handleDrawerToggle}
            sx={{
              display: { xs: "block", md: "none" },
              color: "white",
              p: { xs: 0.25, sm: 0.5 },
              flexShrink: 0
            }}
          >
            <CloseIcon sx={{ fontSize: "clamp(18px, 4vw, 24px)" }} />
          </IconButton>
        </Box>
      )}

      <Divider />

      {/* Menu Items with optimized scrolling */}
      <List sx={{ 
        flex: 1, 
        py: { xs: 1, sm: 2 }, 
        overflowY: "auto",
        overflowX: "hidden",
        '&::-webkit-scrollbar': {
          width: '6px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(0,0,0,0.2)',
          borderRadius: '3px',
        }
      }}>
        {getMenuItems().map((item, index) => (
          <ListItem key={index} disablePadding sx={{ mb: 0.5, px: { xs: 0.5, sm: 0 } }}>
            <ListItemButton
              onClick={() => handleNavigation(item.path)}
              sx={{
                mx: { xs: 0.5, sm: 1 },
                borderRadius: 1,
                py: { xs: 1, sm: 1.25 },
                px: { xs: 1, sm: 1.5 },
                minHeight: "40px",
                "&:hover": {
                  background: "#e0f2f1",
                },
                ...(location.pathname === item.path && {
                  background: "linear-gradient(155deg, rgba(3, 108, 117, 0.94) 20%, rgba(0, 169, 181, 0.56) 100%)",
                  color: "white",
                  "&:hover": {
                    backgroundColor: "#005662",
                  },
                }),
              }}
            >
              <Box sx={{ 
                mr: { xs: 1.5, sm: 2 }, 
                display: "flex", 
                color: location.pathname === item.path ? "white" : "#006D77",
                flexShrink: 0,
                '& svg': {
                  fontSize: "clamp(18px, 3.5vw, 24px)"
                }
              }}>
                {item.icon}
              </Box>
              <ListItemText 
                primary={item.text} 
                primaryTypographyProps={{ 
                  fontSize: "clamp(12px, 2.2vw, 14px)", 
                  fontWeight: location.pathname === item.path ? 600 : 400,
                  lineHeight: 1.3
                }} 
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      <Divider />

      {/* Logout Button */}
      {user && (
        <ListItem disablePadding sx={{ p: { xs: 0.5, sm: 1 }, flexShrink: 0 }}>
          <ListItemButton
            onClick={handleLogoutClick}
            sx={{
              mx: { xs: 0.5, sm: 1 },
              borderRadius: 1,
              color: "#d32f2f",
              py: { xs: 1, sm: 1.25 },
              px: { xs: 1, sm: 1.5 },
              minHeight: "40px",
              "&:hover": {
                backgroundColor: "#ffebee",
              },
            }}
          >
            <Box sx={{ 
              mr: { xs: 1.5, sm: 2 }, 
              display: "flex", 
              flexShrink: 0,
              '& svg': {
                fontSize: "clamp(18px, 3.5vw, 24px)"
              }
            }}>
              <LogoutIcon />
            </Box>
            <ListItemText 
              primary="Logout" 
              primaryTypographyProps={{ 
                fontSize: "clamp(12px, 2.2vw, 14px)", 
                fontWeight: 500 
              }} 
            />
          </ListItemButton>
        </ListItem>
      )}
    </Box>
  );

  // If user is logged in, show sidebar
  if (user) {
    return (
      <>
        {/* Static Top Bar for Mobile */}
        <AppBar 
          position="fixed" 
          sx={{ 
            display: { xs: "block", md: "none" },
            backgroundColor: "#006D77",
            zIndex: (theme) => theme.zIndex.drawer + 1,
            left: 0,
            right: 0
          }}
        >
          <Toolbar sx={{ 
            justifyContent: "space-between", 
            minHeight: "56px !important", 
            px: { xs: 1.5, sm: 2 },
            height: "56px"
          }}>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleDrawerToggle}
              sx={{ p: 1 }}
            >
              <MenuIcon sx={{ fontSize: "clamp(20px, 5vw, 28px)" }} />
            </IconButton>
            
            <img
              // src={ayujalogo}
              src={getLogoSrc()}  
              alt="Ayuja Logo"
              style={{ 
                height: "clamp(28px, 6vw, 32px)", 
                cursor: "pointer",
                maxWidth: "50%",
                objectFit: "contain"
              }}
              onClick={() => navigate(getHomeRoute())}
            />
            
            <Box sx={{ width: "40px" }} />
          </Toolbar>
        </AppBar>

        {/* Mobile Drawer */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", md: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: "min(280px, 85vw)",
              maxWidth: "85vw",
            },
          }}
        >
          {drawer}
        </Drawer>

        {/* Desktop Drawer - Fixed with proper positioning */}
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", md: "block" },
            
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: DRAWER_WIDTH,
              // maxWidth: DRAWER_WIDTH_VW,
              borderRight: "1px solid #e0e0e0",
              position: "fixed",
              top: 0,
              bottom: 0,
              left: 0,
              height: "100vh",
              overflow: "hidden"
            },
          }}
          open
        >
          {drawer}
        </Drawer>

        {/* Spacer for mobile top bar */}
        <Box sx={{ display: { xs: "block", md: "none" }, height: "56px" }} />

        {/* Logout Confirmation Dialog */}
        <CustomDialog
          open={logoutDialogOpen}
          title="Confirm Logout"
          message="Are you sure you want to logout?"
          type="warning"
          buttonText="Yes, Logout"
          secondaryButtonText="Cancel"
          onClose={handleLogoutConfirm}
          onSecondaryAction={handleLogoutCancel}
        />
      </>
    );
  }

  // If user is NOT logged in, show only top header
  return (
    <>
      <AppBar 
        position="fixed" 
        sx={{ 
          backgroundColor: "#fff", 
          color: "#153f4b",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          left: 0,
          right: 0,
          top: 0
        }}
      >
        <Toolbar sx={{ 
          justifyContent: "space-between", 
          py: { xs: 1, sm: 1.5 }, 
          minHeight: { xs: "56px", sm: "64px" },
          px: { xs: 2, sm: 3 }
        }}>
          {/* Logo */}
          <Box display="flex" alignItems="center">
            <img 
              // src={ayujalogo} 
              src={getLogoSrc()}  
              alt="Ayuja Logo" 
              style={{ 
                height: "clamp(28px, 6vw, 40px)", 
                cursor: "pointer",
                maxWidth: "150px",
                objectFit: "contain"
              }} 
              onClick={() => navigate("/")}
            />
          </Box>

          {/* Login/Register Buttons */}
          <ToggleButtonGroup
            value={selected}
            exclusive
            onChange={handleChange}
            sx={{
              width: "clamp(120px, 25vw, 150px)",
              height: "clamp(30px, 6vw, 35px)",
              borderRadius: "30px",
              overflow: "hidden",
              border: "1px solid teal",
            }}
          >
            <ToggleButton
              value="login"
              onClick={() => navigate("/Login")}
              sx={{
                textTransform: "none",
                fontWeight: "bold",
                px: { xs: 1.5, sm: 2 },
                fontSize: "clamp(12px, 2.5vw, 14px)",
                "&.Mui-selected": {
                  background: "linear-gradient(to right, seagreen, #22577A)",
                  color: "white",
                },
              }}
            >
              Login
            </ToggleButton>
            <ToggleButton
              value="register"
              onClick={() => navigate("/Register")}
              sx={{
                textTransform: "none",
                fontWeight: "bold",
                px: { xs: 1, sm: 1 },
                fontSize: "clamp(12px, 2.5vw, 14px)",
                "&.Mui-selected": {
                  background: "linear-gradient(to right, seagreen, #22577A)",
                  color: "white",
                },
              }}
            >
              Register
            </ToggleButton>
          </ToggleButtonGroup>
        </Toolbar>
      </AppBar>
      
      {/* Spacer for fixed AppBar */}
      <Box sx={{ height: { xs: "56px", sm: "64px" } }} />
    </>
  );
}

export default Header;